import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import LayoutContent from 'components/Layout/LayoutContent';
import Notification from 'components/Notification';

type FieldResultProps = {
    className?: string;
    name: string;
};

const FieldResult: FC<FieldResultProps> = ({className, name}) => {
    const methods = useFormContext();

    const {
        clearErrors,
        formState: {errors},
    } = methods;

    const {message, type} = errors.root?.[name] || {};

    if (!message) return null;

    return (
        <LayoutContent>
            <Notification
                className={className}
                icon={type === 'error' ? 'warning' : 'success'}
                onClick={() => clearErrors(`root.${name}`)}
                type={type === 'error' ? 'danger' : 'success'}
            >
                {message}
            </Notification>
        </LayoutContent>
    );
};

export default FieldResult;
